var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgItemMutedGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97.4709 23.5517L51.7448 0.423217C50.6378 -0.141072 49.3725 -0.141072 48.2596 0.423217L2.53582 23.5517C1.0433 24.3055 0.057667 25.9645 0.00231633 27.8189C-0.0510922 29.6697 0.822541 31.3989 2.26587 32.2697L47.989 59.9272C48.6196 60.3109 49.3107 60.4985 50.0037 60.4985C50.7003 60.4985 51.3904 60.3109 52.0219 59.9272L97.7473 32.2697C99.1893 31.3989 100.064 29.6697 100.012 27.8189C99.949 25.9645 98.9657 24.3055 97.4709 23.5517Z",
    fill: "#EEEEEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M93.7164 44.2735L50.004 70.722L6.29865 44.2735C4.20633 43.0072 1.61553 43.9056 0.506577 46.2744C-0.610146 48.642 0.181918 51.5799 2.26841 52.8428L47.9916 80.508C48.6221 80.8891 49.3132 81.0789 50.0062 81.0789C50.7028 81.0789 51.3929 80.8917 52.0244 80.508L97.7499 52.8428C99.8315 51.5799 100.623 48.642 99.5124 46.2744C98.395 43.9052 95.8022 43.0069 93.7164 44.2735Z",
    fill: "#EEEEEE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M93.7164 63.2029L50.004 89.6427L6.29865 63.2029C4.20633 61.9356 1.61553 62.8351 0.506577 65.2005C-0.610146 67.5682 0.181918 70.509 2.26841 71.7701L47.9916 99.4265C48.6221 99.8101 49.3132 99.9999 50.0062 99.9999C50.7028 99.9999 51.3929 99.8127 52.0244 99.4265L97.7499 71.7701C99.8315 70.509 100.623 67.5686 99.5124 65.2005C98.395 62.8351 95.8058 61.9352 93.7164 63.2029Z",
    fill: "#EEEEEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItemMutedGrey);
export default __webpack_public_path__ + "static/media/item-muted-grey.c2f39449c29b4651fa3927a3032b53b5.svg";
export { ForwardRef as ReactComponent };